<!--
 * @Author: your name
 * @Date: 2021-09-30 10:28:39
 * @LastEditTime: 2023-03-21 10:31:08
 * @LastEditors: shijian.chen shijian.chen@qunar.com
 * @Description: In User Settings Edit
 * @FilePath: /dmf_ad_currency_h5/src/views/modules/lincoln_national_day/index.vue
-->
<template>
  <div id="main">
    <img
      @click="goBack"
      src="https://source.qunarzz.com/site/images/wns/20220922-shijianchen-arrlf.png"
      class="arrlf"
      alt=""
    />
    <div>
      <video-comp poster="https://source.qunarzz.com/site/images/wns/20230316-shijianchen-thumb.jpg" src="https://source.qunarzz.com/site/images/wns/20230316-shijianchen-video.mp4"></video-comp>
    </div>
    <div class="content">
      [沃尔沃旅行家俱乐部招募2.0] 正式开启!
      #沃尔沃汽车@瑞典旅游局，邀你用北欧生活方式，开启一场全新的旅行成为旅行家俱乐部成员，就有机会和官方一起空降瑞典，体验纯粹的北欧式生活如果你是沃尔沃车主，热爱公路文化、擅长镜头语言，懂得游记和编辑，那就赶快加入我们!
      #北欧式生活的一天 #别赶路去感受路招募详情已放置在评论区，期待你来参与!
    </div>
    <div class="footer">
      <div @click="lookDetail" class="detail">查看详情</div>
      <div @click="share" class="share">
        <span class="share-txt">分享</span><span class="iconfont icon-share"></span>
      </div>
    </div>
  </div>
</template>
<script>
import videoComp from './components/video.vue';
import { shareToPlatform } from '@/utils/hybird';
export default {
  components: {
    videoComp,
  },
  mounted() {},
  data() {
    return {};
  },
  methods: {
    share() {
      // shareToPlatform()
      window.hysdk.showShareItems({
        success: function () {
          // 用户点击了分享dialog中的分享按钮
          // do something
        },
      });
    },
    goBack() {
      window.history.back();
    },
    lookDetail() {
      window.location.href = 'https://www.volvocars.com.cn/zh-cn/';
    },
  },
};
</script>
<style lang='less' scoped='true'>
#main {
  width: 100%;
  height: 100vh;
  background-color: #000;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  position: relative;
}
.arrlf {
  position: absolute;
  left: 20px;
  top: 50px;
  width: 12px;
}
.content {
  width: 240px;
  position: absolute;
  bottom: 80px;
  left: 20px;
  color: #fff;
  font-size: 12px;
  text-align: justify;
}
.footer {
  position: absolute;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 35px;
  position: absolute;
  bottom: 20px;
  left: 0;
  width: 100%;
  color: #fff;
  padding-left: 20px;
  padding-right: 20px;
  z-index: 100;
  box-sizing: border-box;
}
.detail {
  font-size: 16px;
}
.share .iconfont {
  font-size: 16px;
  position: relative;
  top: -1px;
  color: #fff;
}
.share .share-txt{
  position: relative;
  margin-right: 4px;
}
.share {
  width: 70px;
  height: 26px;
  display: flex;
  border-radius: 5px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content:center;
  border:1px solid #fff;
}
.detail {
  padding: 6px 12px;
  background-color: #fff;
  color: #444;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 70px;
  border-radius: 6px;
  height: 24px;
}
</style>